import { Regions } from '@smh/projects/regions';

import { PersonalSelectionHttpClient } from './personal-selection.api';
import { presentPersonalSelectionBlock } from './personal-selection.presenter';
import { type PersonalSelectionBlock } from './personal-selection.vm';

export interface IPersonalSelectionUseCase {
  getPersonalSelectionBlockData: (
    regionId: Regions,
    recordId: number
  ) => Promise<PersonalSelectionBlock | null>;
}

export class PersonalSelectionUseCase implements IPersonalSelectionUseCase {
  private readonly _httpClient: PersonalSelectionHttpClient;
  private readonly _isMobile: boolean;

  constructor(envType: string, isMobile: boolean) {
    this._httpClient = new PersonalSelectionHttpClient({
      envType,
      protocol: 'https'
    });
    this._isMobile = isMobile;
  }

  public async getPersonalSelectionBlockData(
    regionId: Regions,
    recordId: number
  ): Promise<PersonalSelectionBlock | null> {
    try {
      const blockDTO = await this._httpClient.fetchPersonalSelection({
        regionId,
        recordId
      });

      return presentPersonalSelectionBlock(blockDTO, this._isMobile);
    } catch (err) {
      console.error(err);
      return null;
    }
  }
}
